import {supportNative, getErrorFactory, logError} from './util';

const zzc = window.zzc;


/**
 * app分享接口
 *
 * @export
 * @param {object} shareConfig
 * ```js
 * {
 *   title: '',  // 微博没用上title数据
 *   content: '',
 *   photo: '',
 *   shareUrl: '',
 *   sharePlatform: [],
 *   complete: (res) => {}
 * }
 * ```
 * @returns
 */
const DEFAULT_OPTIONS = {
  sharePlatform: []
};

export default function share(options) {
  let errorFactory = getErrorFactory('setTitle');
  options = {...DEFAULT_OPTIONS, ...options};

  if (!supportNative('Share')) {
    return logError(errorFactory('不支持zzcjsbridge'));
  }

  zzc.call('Share', {
    ...options,
    complete: function (res) {
      if (res.state) {
        logError(errorFactory(res.message));
      }

      options.complete && options.complete(res);
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/share.js